export default "__VITE_ASSET__Bt1vP9DG__"